/*
  Image Capture Tool Web Application
  @date 13-03-2021@12:59
  @author Martin A Frith
  @email overlemonsoft@gmail.com
  @website https://overlemon.com
  @copyright Memorable Results
*/

import '@/scss/main.scss'

/* Core */
import Vue from 'vue'
import Buefy from 'buefy'
import axios from 'axios'
import moment from 'moment'

/* Router & Store */
import router from './router'
import store from './store'

/* Service Worker */
// import './registerServiceWorker'

/* Vue. Main component */
import App from './App.vue'

Vue.use(Buefy)

axios.defaults.baseURL = store.state.endpoint

router.beforeEach((to, from, next) => {
  if (to.params.vars) {
    store.dispatch('showLoader', { message: 'Gathering case information. Please wait...' })
    setTimeout(() => {
      if (!to.params.vars) {
        /* not enought data to proceed */
        router.push('/abort')
      } else {
        store.dispatch('caseStart', to.params.vars).then(res => {
          if (!res.vars || !res.vars.case_number) {
            localStorage.removeItem('mycase')
            localStorage.removeItem('uploads')
            router.push('/abort')
            console.log(`❌ case: Not enough data to proceed`)
          } else {
            store.state.mycase.loaded = true
            store.dispatch('hideLoader')
            console.log(`✔️ case`)
            if (res.vars && res.vars.status === 'completed') {
              localStorage.removeItem('mycase')
              localStorage.removeItem('uploads')
              next(`/case/status/${res.vars.status}`)
            } else {
              store.state.mycase.completed = false
              store.state.uploads = {}
              next('/wizard/1')
            }
          }
        }).catch(err => {
          store.state.loaded = true
          console.log(`❌ case: ${err}`)
        })
      }
    }, 3000)
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  store.dispatch('hideLoader')
})

Vue.config.productionTip = false

Vue.filter('dateFormat', value => {
  if (!value) return ''
  value = value.toString()
  return moment(value).format('DD-MM-Y @ H:mm')
})

const translate = term => {
  if (!term) {
    return ''
  }

  term = term.toLowerCase().toString()

  if (!store.state.mycase || !Object.keys(store.state.mycase.terms)) {
    return term
  }

  return store.state.mycase.terms[term] || term
}

Vue.filter('term', term => {
  return translate(term)
})

new Vue({
  mixins: [{
    methods: {
      camelize (input) {
        return input.replace(/\w+/g, txt => {
          return txt.charAt(0).toUpperCase() + txt.substr(1)
        }).replace(/\s/g, '')
      },
      term (term) {
        return translate(term)
      }
    }
  }],
  router,
  store,
  data () {
    return {
      langsAvailable: {
        en: 'English',
        fr: 'Français',
        de: 'Deustche',
        es: 'Español',
        nl: 'Nederlands'
      }
    }
  },
  render: h => h(App)
}).$mount('#app')

moment.locale('es')

window.onerror = function (msg, url, lineNo, columnNo, error) {
  alert(`error: ${msg}:${lineNo}`)
}
